import { Truck, Check, PartyPopper } from "lucide-react";

interface FreeShippingProgressProps {
  currentAmount: number;
  freeShippingThreshold: number;
  currency?: string;
}

export const FreeShippingProgress = ({
  currentAmount,
  freeShippingThreshold,
  currency = "€",
}: FreeShippingProgressProps) => {
  const progress = Math.min((currentAmount / freeShippingThreshold) * 100, 100);
  const remaining = Math.max(freeShippingThreshold - currentAmount, 0);
  const isFreeShipping = remaining <= 0;

  return (
    <div className="p-4 bg-accent rounded-xl">
      <div className="flex items-center gap-3 mb-3">
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center ${
            isFreeShipping ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground"
          } transition-colors`}
        >
          {isFreeShipping ? <Check className="w-5 h-5" /> : <Truck className="w-5 h-5" />}
        </div>
        <div className="flex-1">
          {isFreeShipping ? (
            <p className="text-sm font-semibold text-primary flex items-center gap-1.5">
              <PartyPopper className="w-4 h-4" />
              Máte dopravu zadarmo!
            </p>
          ) : (
            <p className="text-sm text-foreground">
              Nakúpte ešte za{" "}
              <span className="font-semibold text-primary">
                {remaining.toFixed(2).replace(".", ",")} {currency}
              </span>{" "}
              pre dopravu zadarmo
            </p>
          )}
        </div>
      </div>
      <div className="progress-bar-container">
        <div
          className="progress-bar-fill"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="flex justify-between mt-2 text-xs text-muted-foreground">
        <span>0 {currency}</span>
        <span>{freeShippingThreshold} {currency}</span>
      </div>
    </div>
  );
};
